import $ from 'jquery';
import ShopifySurfacePickUp from '@pixelunion/shopify-surface-pick-up';

import RecipientForm from '@pixelunion/pxs-gift-card-recipient-form';
import VariantHelper from '../utils/VariantHelper';
import ProductGallery from './ProductGallery';
import Goal from './Goal';
import Modal from './Modal';
import PaymentTerms from '../utils/PaymentTerms';

export default class ProductDetails {
  constructor(section) {
    this.$el = $(section.el);

    this.el = section.el;
    this.data = section.data;

    this.$productForm = $('[data-product-form]', this.$el);
    this.formID = this.$productForm.attr('data-product-form');
    this.processing = false;

    // Form selectors
    this.productForm = `product-form-${this.formID}`;
    this.$addToCartButton = $('.add-to-cart input', this.$el);
    this.$priceArea = $('.product-price', this.$el);
    this.$productMessage = $('[data-product-message]', this.$el);

    this.paymentTerms = new PaymentTerms(this.el);

    this.surfacePickUp = new ShopifySurfacePickUp(this.el.querySelector('[data-surface-pick-up]'));
    this.surfacePickUp.onModalRequest(contents => {
      this.modal = new Modal(
        {
          el: this.el.querySelector('[data-modal-id="surface-pick-up"]'),
          callbacks: {
            onOpen: ({ modal }) => {
              const modalHeader = modal.querySelector('[data-modal-header]');
              const modalContents = modal.querySelector('[data-modal-contents]');

              if (this.productJSON) {
                const variant = this.variantHelpers
                  ? this.variantHelpers.getCurrentVariant()
                  : this.productJSON.variants[0];

                modalHeader.innerHTML = `
                  <h2 class="surface-pick-up-modal__header">
                    ${this.productJSON.title}
                  </h2>
                  ${this.variantHelpers ? `<span class="surface-pick-up-modal__subtitle">${variant.title}</span>` : ''}
                `;
              }

              modalContents.innerHTML = contents;
            },
          },
        },
        {
          reposition: false,
        },
      );
      this.modal.open();
      this.modal.showModal();
    });

    this.recipientFormEl = this.el.querySelector('[data-recipient-form]');

    if (this.recipientFormEl) {
      this.recipientEmail = this.recipientFormEl.querySelector('[data-recipient-form-email-input]');
      this.recipientForm = new RecipientForm(this.el);
    }

    // Setup product information
    const $productJSON = $(`[data-product-json-${this.formID}]`, this.$el);
    const $productSettings = $(`[data-product-settings-${this.formID}]`, this.$el);

    this.productGoal = new Goal({
      el: this.$el.find('[data-product-goal-block]'),
      context: 'block',
    })

    this.productGallery = new ProductGallery(
      this.el.querySelector('[data-product-gallery]'),
      {
        enable_video_autoplay: this.data.settings.gallery_enable_video_autoplay,
        enable_video_looping: this.data.settings.gallery_enable_video_looping,
        enable_zoom: this.data.settings.gallery_enable_zoom,
      },
    );

    if (!$productJSON.length) { return; }

    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    this.$variantDropdowns = $(`[data-option-select=${this.formID}]`, this.$el);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;

    this.$el.on('click', '.number-input-nav-item', event => this.amount(event));

    this.$addToCartButton.on('click', event => this.addToCart(event));

    if (this.$variantDropdowns.length) {
      this.setupVariants();
    } else {
      this.surfacePickUp.load(this.productJSON.variants[0].id); // Single variant product
    }
  }

  prepareRemove() {
    this.unload();
    if (this.variantHelpers) {
      this.variantHelpers.prepareRemove();
    }
  }

  setupVariants() {
    const dropdownSettings = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $selector: this.$variantDropdowns,
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      type: 'select',
      productGallery: this.productGallery
    };

    this.variantHelpers = new VariantHelper(dropdownSettings);
    this.variantHelpers.onVariantChange(variant => {
      if (!variant) return;
      const id = { variant };
      this.surfacePickUp.load(id);
      this.paymentTerms.update(id);
    });
    this.$variantDropdowns.trigger('change');
  }

  addToCart(e) {
    e.preventDefault();

    const isPasswordPage = document.querySelector('.template-password');

    if (this.processing) { return; }

    this.processing = true;

    if (this.recipientFormEl) {
      this.recipientFormEl.classList.remove('recipient-form--has-errors');
    }

    this.$el.find('.product-wrap').addClass('loading');

    const quantity = this.$el.find("input[name='quantity']").val();

    if ((quantity === '') || (quantity === '0') || isPasswordPage) {
      setTimeout(() => {
        this.$el.find("input[name='quantity']")
          .addClass('error');
        if (isPasswordPage) {
          this.$productMessage.text(this.productSettings.errorText);
        } else {
          this.$productMessage.text(this.productSettings.setQuantityText);
        }
        this.$el.find('.product-wrap')
          .removeClass('loading added-success')
          .addClass('added-error');
        this.processing = false;
      },
      500);
    } else {

      $.ajax({
        type: 'POST',
        url: `${window.Theme.routes.cart_url}/add.js`,
        data: this.$productForm.serialize(),
        dataType: 'json',
      })
        // On success
        .done((cartItem) => {
          setTimeout(() => {
            Shopify.getCart(cart => $('.header-cart-count').text(cart.item_count));

            const successMessage = this.productSettings.successMessage.replace('** product **', `<em>${cartItem.title}</em>`);

            this.$productMessage.html(successMessage);
            this.$el.find("input[name='quantity']")
              .removeClass('error');
            this.$el.find('.product-wrap')
              .removeClass('loading added-error')
              .addClass('added-success');
            $('.header-cart-count').addClass('active');

            this.$addToCartButton.val(this.productSettings.addToCartText);

            this.processing = false;

            // Enable cart redirect if setting enabled
            if (this.productSettings.cartRedirect || document.querySelector('.template-cart')) {
              window.location.href = window.Theme.routes.cart_url;
            }
          },
          1000);
        })
        // On failure
        .fail(response => this.handleErrors(response));
    }
  }

  handleErrors(errors) {
    const errorMessage = JSON.parse(errors.responseText);
    const productTitle = this.productJSON.title;

    let errorDescription = errorMessage.description;

    if (typeof errorMessage.description === 'string') {
      if ((errorMessage.description ? errorMessage.description.indexOf(productTitle) : -1) > -1) {
        errorDescription = errorDescription.replace(productTitle, `<em>${productTitle}</em>`);
      }
    }

    if (errorMessage.message === 'Cart Error' || errorMessage.description.email) {
      setTimeout(() => {
        this.$el.find("input[name='quantity']").removeClass('error');
        this.$productMessage.html(errorDescription);
        this.$el.find('.product-wrap').removeClass('loading added-success').addClass('added-error');
        this.$addToCartButton.val(this.productSettings.addToCartText);

        if (this.recipientFormEl) {
          this.recipientFormEl.classList.add('recipient-form--has-errors');
        }

        this.processing = false;
      },
      1000);
    }
  }

  amount(e) {
    const input = $(e.currentTarget).parents('.number-input-wrapper').find('input');
    const result = parseFloat(input.val());
    if ($(e.currentTarget).hasClass('icon-plus')) {
      if (result + 1 != 0) {
        input.val(result + 1);
      }
    }
    if ($(e.currentTarget).hasClass('icon-minus') && result > 0) {
      if (result - 1 != 0) {
        input.val(result - 1);
      }
    }
  }

  unload() {
    this.$el
      .off('submit', '.product-form')
      .off('click', '.number-input-nav-item');

    this.productGallery.unload();
  }
}
